import { $t } from '@/i18n';
import { message } from '@utils/wuji-message';
import BannerService from '@/services/banner';

export default {
  state: {
    bannerData: null,
    showBanner: false,
  },
  getters: {
  },
  actions: {
    async fetchBannerData({ commit }) {
      try {
        const { pathname } = window.location;
        const result = await BannerService.fetchBannerData(pathname);
        if (result) {
          commit('updateBannerData', result);
          return result;
        }
      } catch (err) {
        console.error(err);
        message.error($t('k_e216071d'), err.message);
      }
    },
    async fetchBannerRecord({ commit }, { id } = {}) {
      try {
        const result = await BannerService.fetchBannerRecord(id);
        commit('updateBannerRecord', result);
        return result;
      } catch (err) {
        console.error(err);
        message.error($t('k_e69577b9'), err.message);
      }
    },
  },
  mutations: {
    updateBannerData(state, payload) {
      state.bannerData = payload;
    },
    updateBannerRecord(state, payload) {
      state.showBanner = payload;
    },
  },
};
